import { aggregateRows, calculateMachineSimulationRow } from "../utils/simulationCalc";

export const simulationEngineMock = {
  runScenario({
    scenario,
    machines,
    planRows,
    realizedRows,
    operatorsSummary,
    maintenanceSchedule,
    periodContext,
  }) {
    const period = scenario?.period;
    const planMap = new Map(
      (planRows || [])
        .filter((row) => row.period === period)
        .map((row) => [`${row.period}_${row.machineId}`, row])
    );
    const realizedMap = new Map(
      (realizedRows || [])
        .filter((row) => row.period === period)
        .map((row) => [`${row.period}_${row.machineId}`, row])
    );
    const maintenanceHoursByMachine = periodContext?.maintenanceHoursByMachine || {};
    const contractHoursByMachinePeriod = periodContext?.contractHoursByMachinePeriod || {};
    const recommendedOperatorsByPeriod = periodContext?.recommendedOperatorsByPeriod || {};
    const machineOperatorFactorByPeriod = periodContext?.machineOperatorFactorByPeriod || {};
    const maintenanceMap = new Map();
    Object.entries(maintenanceHoursByMachine).forEach(([compoundKey, hours]) => {
      const [keyPeriod, machineId] = String(compoundKey).split("::");
      if (keyPeriod !== period) return;
      maintenanceMap.set(`${keyPeriod}_${machineId}`, Number(hours) || 0);
    });

    const avgRequiredPerMachine =
      (machines || []).reduce((acc, machine) => acc + (Number(machine.requiredOperators) || 0), 0) /
        Math.max(1, (machines || []).length) || 1;

    const rows = (machines || []).map((machine) => {
      const plan = planMap.get(`${period}_${machine.id}`);
      const realized = realizedMap.get(`${period}_${machine.id}`);

      return calculateMachineSimulationRow({
        machine,
        period,
        planValue: plan?.planUnits || 0,
        realizedValue: realized?.realizedUnits || 0,
        parameters: scenario?.parameters || {},
        operatorBaseline: {
          recommendedOperators:
            Number(recommendedOperatorsByPeriod[period]) ||
            Number(operatorsSummary?.recommendedOperators) ||
            1,
          avgRequiredPerMachine,
        },
        scheduledMaintenanceHours: maintenanceMap.get(`${period}_${machine.id}`) || 0,
        effectiveContractHours:
          Number(contractHoursByMachinePeriod[`${period}::${machine.id}`]) ||
          Number(scenario?.parameters?.contractHours) ||
          0,
        machineOperatorCalendarFactor:
          Number(machineOperatorFactorByPeriod[`${period}::${machine.id}`]) || 1,
      });
    });

    const aggregate = aggregateRows(rows, scenario?.parameters?.tolerancePercent || 0);

    return {
      scenarioId: scenario?.id,
      scenarioName: scenario?.name,
      period,
      ranAt: new Date().toISOString(),
      rows,
      aggregate,
      meta: {
        engine: "simulationEngine.mock",
        source: "front-only-mock",
        machineCount: rows.length,
        maintenanceEntriesUsed:
          Number(periodContext?.maintenanceEntriesCountByPeriod?.[period]) || 0,
      },
    };
  },
};

export default simulationEngineMock;
